import React, { useEffect,useState,useRef } from 'react'
import {Button} from 'primereact/button'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector} from 'react-redux'
import './SecurityQuestion.css'
import {getUserInfo,getChallengeQuestions,updateUserInfo,saveSecurityQuestions, getUserDetails} from '../../../actions'
import { Toast } from 'primereact/toast'
import {Dropdown} from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext';
import { Oval } from  'react-loader-spinner'
import {Messages} from 'primereact/messages'

const SecurityQuestion = () => {
  
  const history = useHistory()
  const toast = useRef(null)
  const messages = useRef(null)
  const dispatch = useDispatch()
  const userinfo = useSelector(state=>state.userInfoReducers)
  const challengeQuestions = useSelector(state => state.challengeQuestionsReducers)
  const userdetails = useSelector(state=> state.userReducers)

  const [invalid, setInvalid] = useState({
    answer1: false,
    answer2: false,
    answer3: false,
    answer2unique: false,
    answer3unique: false
  })

  const resetValidation = (fields) => {
    var fieldsUpdate = {}
    if (typeof (fields) === 'string') {
      fieldsUpdate[`${fields}`] = false
    } else if (Array.isArray(fields)) {
      fields.forEach(item => {
        fieldsUpdate[`${item}`] = false
      })
    }
    setInvalid(Object.assign({}, invalid, fieldsUpdate))
  }

  const validateOnSubmit = () => {
    var allowSubmit = true;
    var invalidJSON = {}

    if (userinfo.data.answer1 === null) {
      Object.assign(invalidJSON, { answer1: true })
      allowSubmit = false
    }

    if (userinfo.data.answer2 === null) {
      Object.assign(invalidJSON, { answer2: true })
      allowSubmit = false
    }

    if (userinfo.data.answer3 === null) {
      Object.assign(invalidJSON, { answer3: true })
      allowSubmit = false
    }
    if (userinfo.data.answer1 !== null && userinfo.data.answer2 !== null) {
      if (userinfo.data.answer1 === userinfo.data.answer2) {
        Object.assign(invalidJSON, { answer2unique: true })
        allowSubmit = false
      }
    }

    if (userinfo.data.answer1 !== null && userinfo.data.answer3 !== null) {
      if (userinfo.data.answer1 === userinfo.data.answer3) {
        Object.assign(invalidJSON, { answer3unique: true })
        allowSubmit = false
      }
    }

    if (userinfo.data.answer2 !== null && userinfo.data.answer3 !== null) {
      if (userinfo.data.answer2 === userinfo.data.answer3) {
        Object.assign(invalidJSON, { answer3unique: true })
        allowSubmit = false
      }
    }

    if (allowSubmit) {
      //validation pass, will call update password request
      dispatch(saveSecurityQuestions(Object.assign({},userinfo.data,{refnum:userdetails.data.refnum})))
      setRequestingSaveQuestions(true)
    } else {
      setInvalid(Object.assign({}, invalid, invalidJSON))
    }
  }

  const [requestingGetUserInfo,setRequestingGetUserInfo] = useState(false)
  const [requestGetChallengeQuestions, setRequestGetChallengeQuestion] = useState(false)
  const [requestingGetUserDetails,setRequestingGetUserDetails] = useState(false)
  const [requestingSaveQuestions,setRequestingSaveQuestions] = useState(false)
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    if (requestGetChallengeQuestions && challengeQuestions.requesting_get_successful) {
      fetchUserInfo()
      setRequestGetChallengeQuestion(false)
    }
    if (requestGetChallengeQuestions && challengeQuestions.message !== null) {
      toast.current.show({ severity: 'error', summary: "Challenge Questions API", detail: "There was an unexpected error, please refresh the page and try again. If the problem persists, please contact help desk for support.", sticky: true });
      setRequestGetChallengeQuestion(false)
    }
    
    if (requestingGetUserInfo && userinfo.requesting_get_successful) {
      if(userinfo.data.emptyQuestions){
        //messages.current.show({ severity: 'error', summary: "", detail: "Security Questions and Answers for the user have not been set. Please set them first.", sticky: true });
      }
      setRequestingGetUserInfo(false)
    }
    if (requestingGetUserInfo && userinfo.message !== null) {
        toast.current.show({ severity: 'error', summary: "Retrieve User Info API", detail: userinfo.message, sticky: true });
        setRequestingGetUserInfo(false)
    }

    //Get userdetails
    if (requestingGetUserDetails && userdetails.requesting_get_successful) {
      fetchChallengeQuestions()
      setRequestingGetUserDetails(false)
    }
    if (requestingGetUserDetails && userdetails.message !== null) {
      toast.current.show({ severity: 'error', summary: "Get User Details API", detail: userdetails.message, sticky: true });
      setRequestingGetUserDetails(false)
    }

    //Save Security Questions
    if (requestingSaveQuestions && userinfo.requesting_save_successful) {
      setRequestingSaveQuestions(false)
      toast.current.show({ severity: 'success', summary: "", detail: "Security questions have been update successfully.", sticky: true });
      //route to my-profile
      //history.replace('/auth/my-profile')
      history.push({
        pathname: '/unauth/update-success',
        state: {
          title:"Security Question",
          message:"Your new security questions has been updated."
        },
      });
    }
    if (requestingSaveQuestions && userinfo.message !== null) {
        toast.current.show({ severity: 'error', summary: "Save Security Questions API", detail: userinfo.message, sticky: true });
        setRequestingSaveQuestions(false)
    }

  })


  const fetchUserDetails= ()=>{
    dispatch(getUserDetails({}))
    setRequestingGetUserDetails(true)
  }
  const fetchUserInfo = ()=>{
    dispatch(getUserInfo({refnum:userdetails.data.refnum}))
    setRequestingGetUserInfo(true)
  }

  const fetchChallengeQuestions = ()=>{
    dispatch(getChallengeQuestions())
    setRequestGetChallengeQuestion(true)
  }

  useEffect(() => {
    fetchUserDetails()
  }, [])

  return <div className="rightside-container">
    <Toast ref={toast} />
    <div className="rightside-body">
    <div>
        <div className="activate-account-card">
        <div className="center">
          <div className="update-security-title">Update Security Questions</div>
          <div className="security-question-title">Security questions are required to reset your password. Choose questions you can remember.</div>
          <hr/>
          <Messages ref={messages}></Messages>
          {!userinfo.requesting_get&&userinfo.data.challengeQuestions ? <div className="security-question-inner">
            <div>
              <div className="label">Question 1</div>
              <div><Dropdown
                options={
                  challengeQuestions.data.questions ? 
                  challengeQuestions.data.questions.filter(item => item.value !== userinfo.data.question2 && item.value !== userinfo.data.question3) 
                  :[]
                }
                placeholder="Select a question"
                value={userinfo.data.question1||''}
                onChange={(e) => {
                  var questions = JSON.parse(JSON.stringify(userinfo.data.challengeQuestions))
                  questions[0] = e.value
                dispatch(updateUserInfo(Object.assign({}, userinfo.data, { challengeQuestions:questions,question1: e.value })))
                }} />
              </div>
              <div className="answer-container">
                <InputText placeholder="Answer" value={userinfo.data.answer1 || ''} onChange={(e) => {
                  resetValidation('answer1')
                  dispatch(updateUserInfo(Object.assign({}, userinfo.data, { answer1: e.target.value !== '' ? e.target.value : null })))
                }} />
              </div>
              {invalid.answer1 ? <small> <div className="p-error top-margin">Answer to question 1 is required</div></small> : null}
            </div>

            <div>
              <div className="label">Question 2</div>
              <div><Dropdown
                options={ challengeQuestions.data.questions ? 
                  challengeQuestions.data.questions.filter(item => item.value !== userinfo.data.question1 && item.value !== userinfo.data.question3)
                :[]}
                placeholder="Select a question"
                value={userinfo.data.question2}
                onChange={(e) => {
                  dispatch(updateUserInfo(Object.assign({}, userinfo.data, { question2: e.value })))
                }} />
              </div>
              <div className="answer-container">
                <InputText placeholder="Answer" value={userinfo.data.answer2 || ''} onChange={(e) => {
                  resetValidation(['answer2', 'answer2unique'])
                  dispatch(updateUserInfo(Object.assign({}, userinfo.data, { answer2: e.target.value !== '' ? e.target.value : null })))
                }} />
              </div>
              {invalid.answer2 ? <small> <div className="p-error top-margin">Answer to question 2 is required</div></small> : null}
              {invalid.answer2unique ? <small> <div className="p-error top-margin">Answer to question 2 was repeated</div></small> : null}
            </div>

            <div>
              <div className="label">Question 3</div>
              <div><Dropdown
                options={challengeQuestions.data.questions ? 
                  challengeQuestions.data.questions.filter(item => item.value !== userinfo.data.question1 && item.value !== userinfo.data.question2)
                : []}
                placeholder="Select a question"
                value={userinfo.data.question3}
                onChange={(e) => {
                  dispatch(updateUserInfo(Object.assign({}, userinfo.data, { question3: e.value })))
                }} />
              </div>
              <div className="answer-container">
                <InputText placeholder="Answer" value={userinfo.data.answer3 || ''} onChange={(e) => {
                  resetValidation(['answer3', 'answer3unique'])
                  dispatch(updateUserInfo(Object.assign({}, userinfo.data, { answer3: e.target.value !== '' ? e.target.value : null })))
                }} />
              </div>
              {invalid.answer3 ? <small> <div className="p-error top-margin">Answer to question 3 is required</div></small> : null}
              {invalid.answer3unique ? <small> <div className="p-error top-margin">Answer to question 3 was repeated</div></small> : null}
            </div> 
            <br />
            <div className="row-btn"><div className="row-btn-link"><Button disabled={requestingSaveQuestions} onClick={() => {
              if(requestingSaveQuestions){
                return
              }
              validateOnSubmit()
            }}>{requestingSaveQuestions ? <i className="pi pi-spin pi-spinner"></i>:<span>&nbsp;&nbsp;</span>}&nbsp;&nbsp;Save</Button></div></div>
          </div>: 
          <div className="loader-container">
            <Oval
              height="34"
              width="34"
              color='rgb(0, 111, 207)'
              secondaryColor='rgb(0, 111, 207)'
              ariaLabel='loading'
            />
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  </div>

}

export default SecurityQuestion